module.exports = __webpack_public_path__ + "img/model_21_zh.fe378201.jpg";